(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/best-bet-row.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/best-bet-row.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const getLogger = svs.core.log.getLogger;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const helpers = svs.components.tipsen.store.helpers;
const utils = svs.components.tipsen.expandedSystems.utils;
const logger = getLogger('tipsen:best-bet-rows');
var _srow = new WeakMap();
var _maxCapRowCount = new WeakMap();
var _totalRowCount = new WeakMap();
var _calculateBestBetRows = new WeakMap();
class BestBetRow {
  constructor(productBet) {
    var _productBet$gameBoard, _productBet$gameBoard2;
    let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$maxCapRowCount = _ref.maxCapRowCount,
      maxCapRowCount = _ref$maxCapRowCount === void 0 ? 60 : _ref$maxCapRowCount;
    _classPrivateFieldInitSpec(this, _srow, []);
    _classPrivateFieldInitSpec(this, _maxCapRowCount, 0);
    _classPrivateFieldInitSpec(this, _totalRowCount, 0);
    _classPrivateFieldInitSpec(this, _calculateBestBetRows, void 0);
    const _ref2 = (_productBet$gameBoard = productBet === null || productBet === void 0 || (_productBet$gameBoard2 = productBet.gameBoard) === null || _productBet$gameBoard2 === void 0 ? void 0 : _productBet$gameBoard2.boards) !== null && _productBet$gameBoard !== void 0 ? _productBet$gameBoard : {},
      boardData = _ref2.boardData,
      systemType = _ref2.systemType,
      systemNum = _ref2.systemNum;
    const productId = productBet.productId;
    const eventTypeId = productId ? getDefinitionByProduct(productId).outcomes.eventTypeId : 1;
    _classPrivateFieldSet(_maxCapRowCount, this, maxCapRowCount);
    const then = new Date();
    _classPrivateFieldSet(_srow, this, helpers.getExpandedRows(boardData, systemType, systemNum, {
      eventTypeId
    }));
    _classPrivateFieldSet(_totalRowCount, this, _classPrivateFieldGet(_srow, this).length);
    logger.info("Expanded srows for ".concat(systemType, " ").concat(systemNum, " ").concat(this.totalRowCount, " in ").concat(Date.now() - then, "ms"));
    _classPrivateFieldSet(_calculateBestBetRows, this, utils.calculateBestBetRows(_classPrivateFieldGet(_srow, this), undefined, undefined));
    this.calculate = this.calculate.bind(this);
  }
  get srow() {
    return _classPrivateFieldGet(_srow, this);
  }
  get totalRowCount() {
    return _classPrivateFieldGet(_totalRowCount, this);
  }
  calculate(drawResultOutcomes, winDivisions) {
    const then = new Date();
    const cacheKey = drawResultOutcomes.join('');
    const correctRowGroups = _classPrivateFieldGet(_calculateBestBetRows, this).call(this, drawResultOutcomes);
    const lowestWinDivision = winDivisions.slice().pop();
    const bestBetRows = [];
    const winDivisionsRowCount = [];
    let currentCount = 0;
    for (const _ref3 of correctRowGroups.entries()) {
      var _ref4 = _slicedToArray(_ref3, 2);
      const index = _ref4[0];
      const group = _ref4[1];
      const winDivision = index + 1;
      const numberOfRowsInGroup = group.length;
      let slice;
      winDivisionsRowCount.push(numberOfRowsInGroup);

      if (lowestWinDivision && lowestWinDivision >= winDivision) {
        bestBetRows.push(group.slice(0, slice));
        currentCount += numberOfRowsInGroup;
        continue;
      } else if (numberOfRowsInGroup + currentCount > _classPrivateFieldGet(_maxCapRowCount, this)) {
        slice = Math.max(_classPrivateFieldGet(_maxCapRowCount, this) - currentCount, 0);
      }
      bestBetRows.push(group.slice(0, slice));
      currentCount += numberOfRowsInGroup;
    }
    logger.debug('winDivisionsRowCount', winDivisionsRowCount);
    logger.debug('calculated best bet rows', bestBetRows);
    logger.info("Calculated (".concat(this.totalRowCount, ") best bet rows for cache ").concat(cacheKey, " in ").concat(Date.now() - then, "ms"));
    return Object.freeze({
      bestBetRows: Object.freeze(bestBetRows),
      winDivisionsRowCount: Object.freeze(winDivisionsRowCount)
    });
  }
}
setGlobal('svs.tipsen.components.bestBetRows.BestBetRow', BestBetRow);

 })(window);